import {PAGE_URL, PERMISSION_KEY} from "../services/constant";
const nebulaDecisionsMenuRegistry = {
    personalize_nebulaDecisions: {
        label: "Nebula Decisions",
        link: PAGE_URL.NEBULA_DECISIONS_PAGE,
        key: PAGE_URL.NEBULA_DECISIONS_PAGE,
        resourceKey: PERMISSION_KEY
    }
}

export default nebulaDecisionsMenuRegistry;
